/**
 * Get the authentication token from localStorage.
 * This is extracted to a separate file to avoid circular dependencies.
 */
export const getTokenFromLS = (): string => {
	return localStorage.getItem("token") as string;
};
